if (!window.sbBrandsAlphabetInitialized) {
  window.sbBrandsAlphabetInitialized = true;

  document.addEventListener("DOMContentLoaded", function () {
    const alphabetLinks = document.querySelectorAll(".sb-alphabet-link");
    const brandGroups = document.querySelectorAll(".sb-brand-group");

    // Hide alphabet links that don't have corresponding brand groups
    const existingGroups = new Set();
    brandGroups.forEach((group) => {
      const groupId = group.getAttribute("id");
      if (groupId) {
        existingGroups.add(groupId);
      }
    });

    alphabetLinks.forEach((link) => {
      const targetId = link.getAttribute("href").substring(1);
      if (!existingGroups.has(targetId)) {
        // link.style.display = "none";
      }
    });

    // Track the last clicked tab
    let lastClickedTab = null;

    // Smooth scroll on click and set active state
    alphabetLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const targetId = this.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Remove active class from all links
          alphabetLinks.forEach((l) => l.classList.remove("active"));

          // Add active class to clicked link
          this.classList.add("active");

          // Remember this as the last clicked tab
          lastClickedTab = this;

          const offset = 100;
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      });
    });

    // Set initial active state (first visible link)
    const firstVisibleLink = Array.from(alphabetLinks).find(
      (link) => link.style.display !== "none"
    );
    if (firstVisibleLink && !lastClickedTab) {
      firstVisibleLink.classList.add("active");
      lastClickedTab = firstVisibleLink;
    }

    // Scroll navigation arrows functionality
    const navWrapper = document.querySelector(".sb-alphabet-nav-wrapper");
    const navElement = document.querySelector(".sb-all-brands-alphabet");
    const leftArrow = document.querySelector(".sb-alphabet-nav-arrow--left");
    const rightArrow = document.querySelector(".sb-alphabet-nav-arrow--right");

    if (navWrapper && navElement && leftArrow && rightArrow) {
      // Scroll amount per click (in pixels)
      const scrollAmount = 200;

      // Check if arrows are needed
      function updateArrowVisibility() {
        const hasOverflow = navElement.scrollWidth > navElement.clientWidth;

        if (!hasOverflow) {
          leftArrow.style.display = "none";
          rightArrow.style.display = "none";
        } else {
          leftArrow.style.display = "flex";
          rightArrow.style.display = "flex";
        }
      }

      // Left arrow click
      leftArrow.addEventListener("click", function () {
        navElement.scrollBy({
          left: -scrollAmount,
          behavior: "smooth",
        });
      });

      // Right arrow click
      rightArrow.addEventListener("click", function () {
        navElement.scrollBy({
          left: scrollAmount,
          behavior: "smooth",
        });
      });

      // Initial check and on window resize
      updateArrowVisibility();
      window.addEventListener("resize", updateArrowVisibility);
    }
  });
}
